<template>
  <div>
    <br />
    <div class="row align-items-end">
      <div class="col-xl-3">
        <label for="">Client Vendeur <span class="text-danger">*</span> </label>
        <vue-select
          :options="sellerCustomers"
          v-model="sellerSale.seller_customer_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-auto">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="sellerSale.date" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Échéance </label>
        <input type="date" v-model="sellerSale.deadline" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Total </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sellerSale.totalPriceTTC"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for="">Montant paye </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sellerSale.amountPaid"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for="">M. reste </label>
        <input
          type="text"
          :disabled="!amounts_change ? true : false"
          v-model="sellerSale.amountUnpaid"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <input
          type="button"
          @click="
            amounts_change ? (amounts_change = false) : (amounts_change = true)
          "
          :value="amounts_change ? 'Désactiver' : 'Modifier les valeurs'"
          class="form-control bg-warning"
        />
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <label for=""> Remarque </label>
        <textarea v-model="sellerSale.remark" class="form-control"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(sellerSale)">
          <i class="bi bi-check-square-fill"></i> Enregistrer les modifcations
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      amounts_change: false,
    };
  },

  methods: {
    async save(data) {
      await this.$store.dispatch("sellerSale/update", data);
    },
    async refresh() {
      await this.$store.dispatch("sellerCustomer/getAll");
      await this.$store.dispatch(
        "sellerSale/show",
        this.$route.params.reference
      );
    },
  },

  computed: {
    ...mapGetters("sellerSale", {
      sellerSale: "getSellerSale",
    }),
    ...mapGetters("sellerCustomer", {
      sellerCustomers: "getAll",
    }),
  },

  async beforeMount() {
    await this.$store.dispatch("sellerCustomer/getAll");
    await this.$store.dispatch("sellerSale/show", this.$route.params.reference);
  },
};
</script>
